import { c as create_ssr_component, e as escape, j as null_to_empty, h as add_styles, d as add_attribute, k as createEventDispatcher, v as validate_component, m as missing_component, f as each } from "./ssr.js";
import "devalue";
import { S as StdHeading, a as StdParagraph, B as Button } from "./Button.js";
const BackgrounHeading_svelte_svelte_type_style_lang = "";
const css$3 = {
  code: ".huggy.svelte-dcdscx{align-self:flex-start}h1.svelte-dcdscx{font-size:80px;color:#fff;font-weight:700;padding:0 20px;margin:0;text-align:center;text-transform:uppercase}@media screen and (max-width: 800px){h1.svelte-dcdscx{font-size:50px}}.orange.svelte-dcdscx{background-color:#f36d21}.blue.svelte-dcdscx{background-color:#0e76bc}",
  map: null
};
const BackgrounHeading = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { text } = $$props;
  let { font_family = "REM" } = $$props;
  let { color } = $$props;
  if ($$props.text === void 0 && $$bindings.text && text !== void 0)
    $$bindings.text(text);
  if ($$props.font_family === void 0 && $$bindings.font_family && font_family !== void 0)
    $$bindings.font_family(font_family);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  $$result.css.add(css$3);
  return `<div class="huggy svelte-dcdscx"><h1 class="${escape(null_to_empty(color), true) + " svelte-dcdscx"}"${add_styles({ "font-family": font_family })}>${escape(text)}</h1> </div>`;
});
const Email = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const HumanGreetingVariant = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M1.5,4V5.5C1.5,9.65 3.71,13.28 7,15.3V20H22V18C22,15.34 16.67,14 14,14C14,14 13.83,14 13.75,14C9,14 5,10 5,5.5V4M14,4A4,4 0 0,0 10,8A4,4 0 0,0 14,12A4,4 0 0,0 18,8A4,4 0 0,0 14,4Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const InputWrapper_svelte_svelte_type_style_lang = "";
const Input_svelte_svelte_type_style_lang = "";
const css$2 = {
  code: ".clickable.svelte-29kigo{cursor:pointer;border-radius:5rem}.clickable.svelte-29kigo:hover{background:rgba(21,24,28,0.1)}.clickable.svelte-29kigo:active{background:rgba(21,24,28,0.2)}textarea.svelte-29kigo{appearance:none;border:none;outline:none;background:none;flex:1;height:33rem;width:100%;padding:1.5rem 3rem;font-size:1.6rem;resize:none}textarea.svelte-29kigo::placeholder{opacity:0.4}input.svelte-29kigo{appearance:none;border:none;outline:none;background:none;flex:1;width:100%;padding:1.5rem 3rem;padding-left:0;font-size:1.6rem}input.svelte-29kigo::placeholder{opacity:0.4}.input-pseudo-wrapper.svelte-29kigo{position:relative;overflow:visible;padding:0 0.6rem;border-radius:2.6rem;align-items:center;cursor:text;display:flex;background:#fff}.icon.svelte-29kigo{font-size:2rem;padding:0.6rem;margin-left:38px;color:#f36d21;display:inline-flex;align-items:center}.dark.svelte-29kigo{color:#fff}.error.svelte-29kigo{position:absolute;bottom:-35%;left:50%;transform:translateX(-50%);color:#f2f4fa}.invalid.svelte-29kigo{color:#e25454}",
  map: null
};
const Input = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  createEventDispatcher();
  let { placeholder = "" } = $$props;
  let { invalid } = $$props;
  let { spellcheck = true } = $$props;
  let { type = "" } = $$props;
  let { name = "" } = $$props;
  let { left_icon = null } = $$props;
  let { right_icon = null } = $$props;
  let { left_icon_handler = void 0 } = $$props;
  let { right_icon_handler = void 0 } = $$props;
  let { focus_on_mount = false } = $$props;
  let { value } = $$props;
  let { dark = false } = $$props;
  let { small = true } = $$props;
  let errorColor = false;
  let input_ref;
  if ($$props.placeholder === void 0 && $$bindings.placeholder && placeholder !== void 0)
    $$bindings.placeholder(placeholder);
  if ($$props.invalid === void 0 && $$bindings.invalid && invalid !== void 0)
    $$bindings.invalid(invalid);
  if ($$props.spellcheck === void 0 && $$bindings.spellcheck && spellcheck !== void 0)
    $$bindings.spellcheck(spellcheck);
  if ($$props.type === void 0 && $$bindings.type && type !== void 0)
    $$bindings.type(type);
  if ($$props.name === void 0 && $$bindings.name && name !== void 0)
    $$bindings.name(name);
  if ($$props.left_icon === void 0 && $$bindings.left_icon && left_icon !== void 0)
    $$bindings.left_icon(left_icon);
  if ($$props.right_icon === void 0 && $$bindings.right_icon && right_icon !== void 0)
    $$bindings.right_icon(right_icon);
  if ($$props.left_icon_handler === void 0 && $$bindings.left_icon_handler && left_icon_handler !== void 0)
    $$bindings.left_icon_handler(left_icon_handler);
  if ($$props.right_icon_handler === void 0 && $$bindings.right_icon_handler && right_icon_handler !== void 0)
    $$bindings.right_icon_handler(right_icon_handler);
  if ($$props.focus_on_mount === void 0 && $$bindings.focus_on_mount && focus_on_mount !== void 0)
    $$bindings.focus_on_mount(focus_on_mount);
  if ($$props.value === void 0 && $$bindings.value && value !== void 0)
    $$bindings.value(value);
  if ($$props.dark === void 0 && $$bindings.dark && dark !== void 0)
    $$bindings.dark(dark);
  if ($$props.small === void 0 && $$bindings.small && small !== void 0)
    $$bindings.small(small);
  $$result.css.add(css$2);
  {
    if (invalid) {
      errorColor = true;
    }
  }
  return `<div class="${["input-pseudo-wrapper svelte-29kigo", dark ? "dark" : ""].join(" ").trim()}">${left_icon ? `<div class="${[
    "icon svelte-29kigo",
    (dark ? "dark" : "") + " " + (!!left_icon_handler ? "clickable" : "")
  ].join(" ").trim()}">${validate_component(left_icon || missing_component, "svelte:component").$$render($$result, {}, {}, {})}</div>` : ``} ${small ? `<input${add_attribute("placeholder", placeholder, 0)}${add_attribute("spellcheck", spellcheck, 0)}${add_attribute("type", type, 0)}${add_attribute("name", name, 0)}${add_attribute("value", value, 0)} class="${["svelte-29kigo", (dark ? "dark" : "") + " " + (errorColor ? "invalid" : "")].join(" ").trim()}"${add_attribute("this", input_ref, 0)}> ${invalid ? `<span class="error svelte-29kigo">${escape(invalid)}</span>` : ``}` : `<textarea${add_attribute("placeholder", placeholder, 0)}${add_attribute("spellcheck", spellcheck, 0)}${add_attribute("name", name, 0)} class="${["svelte-29kigo", (dark ? "dark" : "") + " " + (errorColor ? "invalid" : "")].join(" ").trim()}"${add_attribute("this", input_ref, 0)}>${escape(String(value), false)}</textarea> ${invalid ? `<span class="error svelte-29kigo" style="bottom: -5%;">${escape(invalid)}</span>` : ``}`} ${right_icon ? `<div class="${[
    "icon svelte-29kigo",
    (dark ? "dark" : "") + " " + (!!right_icon_handler ? "clickable" : "")
  ].join(" ").trim()}">${validate_component(right_icon || missing_component, "svelte:component").$$render($$result, {}, {}, {})}</div>` : ``}</div> ${slots.default ? slots.default({}) : ``}`;
});
const CountryPicker_svelte_svelte_type_style_lang = "";
const css$1 = {
  code: "select.svelte-1h7tns2{appearance:none;border:none;outline:none;background:#fff;border-radius:4rem;flex:1;width:100%;padding:1.5rem 3rem;font-size:1.6rem}",
  map: null
};
const CountryPicker = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { country } = $$props;
  const countries = [
    { name: "Afghanistan", emoji: "🇦🇫" },
    { name: "Albania", emoji: "🇦🇱" },
    { name: "Algeria", emoji: "🇩🇿" },
    { name: "Andorra", emoji: "🇦🇩" },
    { name: "Angola", emoji: "🇦🇴" },
    {
      name: "Antigua and Barbuda",
      emoji: "🇦🇬"
    },
    { name: "Argentina", emoji: "🇦🇷" },
    { name: "Armenia", emoji: "🇦🇲" },
    { name: "Australia", emoji: "🇦🇺" },
    { name: "Austria", emoji: "🇦🇹" },
    { name: "Azerbaijan", emoji: "🇦🇿" },
    { name: "Bahamas", emoji: "🇧🇸" },
    { name: "Bahrain", emoji: "🇧🇭" },
    { name: "Bangladesh", emoji: "🇧🇩" },
    { name: "Barbados", emoji: "🇧🇧" },
    { name: "Belarus", emoji: "🇧🇾" },
    { name: "Belgium", emoji: "🇧🇪" },
    { name: "Belize", emoji: "🇧🇿" },
    { name: "Benin", emoji: "🇧🇯" },
    { name: "Bhutan", emoji: "🇧🇹" },
    { name: "Bolivia", emoji: "🇧🇴" },
    {
      name: "Bosnia and Herzegovina",
      emoji: "🇧🇦"
    },
    { name: "Botswana", emoji: "🇧🇼" },
    { name: "Brazil", emoji: "🇧🇷" },
    { name: "Brunei", emoji: "🇧🇳" },
    { name: "Bulgaria", emoji: "🇧🇬" },
    { name: "Burkina Faso", emoji: "🇧🇫" },
    { name: "Burundi", emoji: "🇧🇮" },
    { name: "Cabo Verde", emoji: "🇨🇻" },
    { name: "Cambodia", emoji: "🇰🇭" },
    { name: "Cameroon", emoji: "🇨🇲" },
    { name: "Canada", emoji: "🇨🇦" },
    {
      name: "Central African Republic",
      emoji: "🇨🇫"
    },
    { name: "Chad", emoji: "🇹🇩" },
    { name: "Chile", emoji: "🇨🇱" },
    { name: "China", emoji: "🇨🇳" },
    { name: "Colombia", emoji: "🇨🇴" },
    { name: "Comoros", emoji: "🇰🇲" },
    { name: "Congo", emoji: "🇨🇬" },
    { name: "Costa Rica", emoji: "🇨🇷" },
    { name: "Croatia", emoji: "🇭🇷" },
    { name: "Cuba", emoji: "🇨🇺" },
    { name: "Cyprus", emoji: "🇨🇾" },
    { name: "Czechia", emoji: "🇨🇿" },
    {
      name: "Democratic Republic of the Congo",
      emoji: "🇨🇩"
    },
    { name: "Denmark", emoji: "🇩🇰" },
    { name: "Djibouti", emoji: "🇩🇯" },
    { name: "Dominica", emoji: "🇩🇲" },
    {
      name: "Dominican Republic",
      emoji: "🇩🇴"
    },
    { name: "Ecuador", emoji: "🇪🇨" },
    { name: "Egypt", emoji: "🇪🇬" },
    { name: "El Salvador", emoji: "🇸🇻" },
    { name: "Equatorial Guinea", emoji: "🇬🇶" },
    { name: "Eritrea", emoji: "🇪🇷" },
    { name: "Estonia", emoji: "🇪🇪" },
    { name: "Eswatini", emoji: "🇸🇿" },
    { name: "Ethiopia", emoji: "🇪🇹" },
    { name: "Fiji", emoji: "🇫🇯" },
    { name: "Finland", emoji: "🇫🇮" },
    { name: "France", emoji: "🇫🇷" },
    { name: "Gabon", emoji: "🇬🇦" },
    { name: "Gambia", emoji: "🇬🇲" },
    { name: "Georgia", emoji: "🇬🇪" },
    { name: "Germany", emoji: "🇩🇪" },
    { name: "Ghana", emoji: "🇬🇭" },
    { name: "Greece", emoji: "🇬🇷" },
    { name: "Grenada", emoji: "🇬🇩" },
    { name: "Guatemala", emoji: "🇬🇹" },
    { name: "Guinea", emoji: "🇬🇳" },
    { name: "Guinea-Bissau", emoji: "🇬🇼" },
    { name: "Guyana", emoji: "🇬🇾" },
    { name: "Haiti", emoji: "🇭🇹" },
    { name: "Holy See", emoji: "🇻🇦" },
    { name: "Honduras", emoji: "🇭🇳" },
    { name: "Hungary", emoji: "🇭🇺" },
    { name: "Iceland", emoji: "🇮🇸" },
    { name: "India", emoji: "🇮🇳" },
    { name: "Indonesia", emoji: "🇮🇩" },
    { name: "Iran", emoji: "🇮🇷" },
    { name: "Iraq", emoji: "🇮🇶" },
    { name: "Ireland", emoji: "🇮🇪" },
    { name: "Israel", emoji: "🇮🇱" },
    { name: "Italy", emoji: "🇮🇹" },
    { name: "Jamaica", emoji: "🇯🇲" },
    { name: "Japan", emoji: "🇯🇵" },
    { name: "Jordan", emoji: "🇯🇴" },
    { name: "Kazakhstan", emoji: "🇰🇿" },
    { name: "Kenya", emoji: "🇰🇪" },
    { name: "Kiribati", emoji: "🇰🇮" },
    { name: "Kuwait", emoji: "🇰🇼" },
    { name: "Kyrgyzstan", emoji: "🇰🇬" },
    { name: "Laos", emoji: "🇱🇦" },
    { name: "Latvia", emoji: "🇱🇻" },
    { name: "Lebanon", emoji: "🇱🇧" },
    { name: "Lesotho", emoji: "🇱🇸" },
    { name: "Liberia", emoji: "🇱🇷" },
    { name: "Libya", emoji: "🇱🇾" },
    { name: "Liechtenstein", emoji: "🇱🇮" },
    { name: "Lithuania", emoji: "🇱🇹" },
    { name: "Luxembourg", emoji: "🇱🇺" },
    { name: "Madagascar", emoji: "🇲🇬" },
    { name: "Malawi", emoji: "🇲🇼" },
    { name: "Malaysia", emoji: "🇲🇾" },
    { name: "Maldives", emoji: "🇲🇻" },
    { name: "Mali", emoji: "🇲🇱" },
    { name: "Malta", emoji: "🇲🇹" },
    { name: "Marshall Islands", emoji: "🇲🇭" },
    { name: "Mauritania", emoji: "🇲🇷" },
    { name: "Mauritius", emoji: "🇲🇺" },
    { name: "Mexico", emoji: "🇲🇽" },
    { name: "Micronesia", emoji: "🇫🇲" },
    { name: "Moldova", emoji: "🇲🇩" },
    { name: "Monaco", emoji: "🇲🇨" },
    { name: "Mongolia", emoji: "🇲🇳" },
    { name: "Montenegro", emoji: "🇲🇪" },
    { name: "Morocco", emoji: "🇲🇦" },
    { name: "Mozambique", emoji: "🇲🇿" },
    { name: "Myanmar", emoji: "🇲🇲" },
    { name: "Namibia", emoji: "🇳🇦" },
    { name: "Nauru", emoji: "🇳🇷" },
    { name: "Nepal", emoji: "🇳🇵" },
    { name: "Netherlands", emoji: "🇳🇱" },
    { name: "New Zealand", emoji: "🇳🇿" },
    { name: "Nicaragua", emoji: "🇳🇮" },
    { name: "Niger", emoji: "🇳🇪" },
    { name: "Nigeria", emoji: "🇳🇬" },
    { name: "North Korea", emoji: "🇰🇵" },
    { name: "North Macedonia", emoji: "🇲🇰" },
    { name: "Norway", emoji: "🇳🇴" },
    { name: "Oman", emoji: "🇴🇲" },
    { name: "Pakistan", emoji: "🇵🇰" },
    { name: "Palau", emoji: "🇵🇼" },
    { name: "Palestine", emoji: "🇵🇸" },
    { name: "Panama", emoji: "🇵🇦" },
    { name: "Papua New Guinea", emoji: "🇵🇬" },
    { name: "Paraguay", emoji: "🇵🇾" },
    { name: "Peru", emoji: "🇵🇪" },
    { name: "Philippines", emoji: "🇵🇭" },
    { name: "Poland", emoji: "🇵🇱" },
    { name: "Portugal", emoji: "🇵🇹" },
    { name: "Qatar", emoji: "🇶🇦" },
    { name: "Romania", emoji: "🇷🇴" },
    { name: "Russia", emoji: "🇷🇺" },
    { name: "Rwanda", emoji: "🇷🇼" },
    {
      name: "Saint Kitts and Nevis",
      emoji: "🇰🇳"
    },
    { name: "Saint Lucia", emoji: "🇱🇨" },
    {
      name: "Saint Vincent and the Grenadines",
      emoji: "🇻🇨"
    },
    { name: "Samoa", emoji: "🇼🇸" },
    { name: "San Marino", emoji: "🇸🇲" },
    {
      name: "Sao Tome and Principe",
      emoji: "🇸🇹"
    },
    { name: "Saudi Arabia", emoji: "🇸🇦" },
    { name: "Senegal", emoji: "🇸🇳" },
    { name: "Serbia", emoji: "🇷🇸" },
    { name: "Seychelles", emoji: "🇸🇨" },
    { name: "Sierra Leone", emoji: "🇸🇱" },
    { name: "Singapore", emoji: "🇸🇬" },
    { name: "Slovakia", emoji: "🇸🇰" },
    { name: "Slovenia", emoji: "🇸🇮" },
    { name: "Solomon Islands", emoji: "🇸🇧" },
    { name: "Somalia", emoji: "🇸🇴" },
    { name: "South Africa", emoji: "🇿🇦" },
    { name: "South Korea", emoji: "🇰🇷" },
    { name: "South Sudan", emoji: "🇸🇸" },
    { name: "Spain", emoji: "🇪🇸" },
    { name: "Sri Lanka", emoji: "🇱🇰" },
    { name: "Sudan", emoji: "🇸🇩" },
    { name: "Suriname", emoji: "🇸🇷" },
    { name: "Sweden", emoji: "🇸🇪" },
    { name: "Switzerland", emoji: "🇨🇭" },
    { name: "Syria", emoji: "🇸🇾" },
    { name: "Taiwan", emoji: "🇹🇼" },
    { name: "Tajikistan", emoji: "🇹🇯" },
    { name: "Tanzania", emoji: "🇹🇿" },
    { name: "Thailand", emoji: "🇹🇭" },
    { name: "Timor-Leste", emoji: "🇹🇱" },
    { name: "Togo", emoji: "🇹🇬" },
    { name: "Tonga", emoji: "🇹🇴" },
    {
      name: "Trinidad and Tobago",
      emoji: "🇹🇹"
    },
    { name: "Tunisia", emoji: "🇹🇳" },
    { name: "Turkey", emoji: "🇹🇷" },
    { name: "Turkmenistan", emoji: "🇹🇲" },
    { name: "Tuvalu", emoji: "🇹🇻" },
    { name: "Uganda", emoji: "🇺🇬" },
    { name: "Ukraine", emoji: "🇺🇦" },
    {
      name: "United Arab Emirates",
      emoji: "🇦🇪"
    },
    { name: "United Kingdom", emoji: "🇬🇧" },
    {
      name: "United States of America",
      emoji: "🇺🇸"
    },
    { name: "Uruguay", emoji: "🇺🇾" },
    { name: "Uzbekistan", emoji: "🇺🇿" },
    { name: "Vanuatu", emoji: "🇻🇺" },
    { name: "Venezuela", emoji: "🇻🇪" },
    { name: "Vietnam", emoji: "🇻🇳" },
    { name: "Yemen", emoji: "🇾🇪" },
    { name: "Zambia", emoji: "🇿🇲" },
    { name: "Zimbabwe", emoji: "🇿🇼" }
  ];
  country = "United States of America";
  if ($$props.country === void 0 && $$bindings.country && country !== void 0)
    $$bindings.country(country);
  $$result.css.add(css$1);
  return `<select style="appearance: none;" required class="svelte-1h7tns2">${each(countries, (country2) => {
    return `<option${add_attribute("value", country2.name, 0)}>${escape(country2.emoji)} ${escape(country2.name)}</option>`;
  })}</select>`;
});
const Spinner_svelte_svelte_type_style_lang = "";
const ContactSubmission_svelte_svelte_type_style_lang = "";
const css = {
  code: ".wrapper.svelte-rlatng{display:flex;gap:6rem;padding:7rem 5rem;border-radius:4rem;background-color:#f36d21;position:relative;overflow:hidden}@media(max-width: 1200px){.wrapper.svelte-rlatng{flex-direction:column}}.text.svelte-rlatng{flex:1;display:flex;flex-direction:column;z-index:1;gap:19rem}.inputs.svelte-rlatng{display:flex;flex-direction:column;flex:1;gap:2.5rem;z-index:1}.postal.svelte-rlatng{position:absolute;left:-30px;top:-40px}.postal-plane.svelte-rlatng{position:absolute;bottom:0;left:-50px;opacity:1;color:#fff;user-select:none;z-index:0}button.svelte-rlatng{background:none;color:inherit;border:none;padding:0;font:inherit;cursor:pointer;outline:inherit}",
  map: null
};
const ContactSubmission = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { showModal } = $$props;
  let { financing = false } = $$props;
  let { form = null } = $$props;
  let country;
  let email_icon = Email;
  let HumanGreeting = HumanGreetingVariant;
  if ($$props.showModal === void 0 && $$bindings.showModal && showModal !== void 0)
    $$bindings.showModal(showModal);
  if ($$props.financing === void 0 && $$bindings.financing && financing !== void 0)
    $$bindings.financing(financing);
  if ($$props.form === void 0 && $$bindings.form && form !== void 0)
    $$bindings.form(form);
  $$result.css.add(css);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-1cgb0st_START --><script data-svelte-h="svelte-kbqiq4">gtag("event", "conversion", {
      send_to: "AW-10931457919/A766CL-3w_wYEP-ew9wo",
    });<\/script><!-- HEAD_svelte-1cgb0st_END -->`, ""} <div class="wrapper svelte-rlatng"><div class="text svelte-rlatng">${validate_component(StdHeading, "StdHeading").$$render($$result, { size: "large", color: "white" }, {}, {
      default: () => {
        return `${financing ? `Apply for financing now!` : `... Or You can Contact Us Now!`}`;
      }
    })} <div>${validate_component(StdParagraph, "StdParagraph").$$render($$result, { size: "large", color: "white" }, {}, {
      default: () => {
        return `${financing ? `Send us a message to enquire about your eligibility for financing` : `We can’t wait to have you on-board`}`;
      }
    })} <br> ${validate_component(StdParagraph, "StdParagraph").$$render($$result, { size: "large", color: "white" }, {}, {
      default: () => {
        return `Feel free to ask us any questions`;
      }
    })}</div></div> <form method="POST" action="?/submit" class="inputs svelte-rlatng">${validate_component(Input, "Input").$$render(
      $$result,
      {
        value: form?.data?.name ?? "",
        invalid: form?.errors?.name ?? "",
        spellcheck: false,
        type: "text",
        name: "name",
        placeholder: "Name",
        left_icon: HumanGreeting
      },
      {},
      {}
    )} ${validate_component(Input, "Input").$$render(
      $$result,
      {
        value: form?.data?.email ?? "",
        invalid: form?.errors?.email ?? "",
        spellcheck: false,
        type: "text",
        name: "email",
        placeholder: "Email",
        left_icon: email_icon
      },
      {},
      {}
    )} ${validate_component(CountryPicker, "CountryPicker").$$render(
      $$result,
      { country },
      {
        country: ($$value) => {
          country = $$value;
          $$settled = false;
        }
      },
      {}
    )} <input type="text" name="country" style="display: none;"${add_attribute("value", country, 0)}> ${validate_component(Input, "Input").$$render(
      $$result,
      {
        value: form?.data?.message ?? "",
        invalid: form?.errors?.message ?? "",
        name: "message",
        placeholder: "Message",
        small: false
      },
      {},
      {}
    )} <button class="svelte-rlatng">${validate_component(Button, "Button").$$render(
      $$result,
      {
        centered: true,
        size: "large",
        color: "blue"
      },
      {},
      {
        default: () => {
          return `${`Send`}`;
        }
      }
    )}</button></form> <div class="postal svelte-rlatng" data-svelte-h="svelte-leksef"><img src="/postal.png" alt="postage"></div> <div class="postal-plane svelte-rlatng" data-svelte-h="svelte-mm6kxd"><img src="/postal_plane.png" alt="plane" width="90%"></div> </div>`;
  } while (!$$settled);
  return $$rendered;
});
export {
  BackgrounHeading as B,
  ContactSubmission as C
};
